export default __webpack_public_path__ + "static/rise-up-portfolio-a8811f563f6116e403ce421d654fdb6b.webp";